import { useSelector } from 'react-redux'
import { editorThunks } from 'store/features/editor/thunks'
import { editorSelectors } from 'store/features/editor/selectors'
import { IActiveTimelineItem } from 'store/types/editor'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { getItemsInRange } from '../utils'
import { dispatch } from 'store'
import { useRef } from 'react'

export const useTimelineRangeSelection = () => {
  const activeTimelineItem = useSelector(editorSelectors.activeTimelineItem)
  const initialAnchorRef = useRef<IActiveTimelineItem | null>(null)
  initialAnchorRef.current = activeTimelineItem.id
    ? activeTimelineItem
    : initialAnchorRef.current

  const timelineItemsSortedByStartTime = useSelector(
    projectDataSelectors.timelineItemsSortedByStartTime
  )
  const hasAnchor = useSelector(editorSelectors.hasActiveTimelineItems)

  const handleRangeSelection = (targetItem: IActiveTimelineItem) => {
    const anchor = initialAnchorRef?.current
    if (!anchor?.id || !targetItem.id) {
      return
    }

    const itemsInRange = getItemsInRange(
      timelineItemsSortedByStartTime,
      anchor.id,
      targetItem.id
    )
    const newActiveTimelineItems = itemsInRange.map(item => ({
      id: item.id,
      type: item.type
    }))

    dispatch(editorThunks.setActiveTimelineItems(newActiveTimelineItems))
    dispatch(editorThunks.setAsideOverlayContent(null))
  }

  return { handleRangeSelection, hasAnchor }
}
